import { CreateTemplateRequestDto } from '@asset-metrix/portal-gateway-client-js';
import { triggerDownloadWithAnchorTag } from '@asset-metrix/portal-ui';

import { getContentDispositionFileName } from '../../utils/contentDisposition';
import { extractErrorMessage } from '../../utils/errorMessage';
import { HttpError } from '../errors';
import { portalGatewayClient } from '../portalGatewayClient';

export const downloadDataIngestionTemplate = async (
  contentId: string,
  data: CreateTemplateRequestDto,
  defaultFileName = 'template.xlsx'
): Promise<void> => {
  const response = await portalGatewayClient.dataIngestion.createTemplate(
    contentId,
    data
  );

  if (!response.ok) {
    let error = response.error;
    try {
      error = await response.json();
    } catch {
      // ignore
    }

    throw new HttpError(
      extractErrorMessage(error, 'Error loading data ingestion entities.'),
      response
    );
  }

  const contentDisposition = response.headers.get('content-disposition');

  const fileName =
    (contentDisposition && getContentDispositionFileName(contentDisposition)) ??
    defaultFileName;

  const blob = await response.blob();
  const blobUrl = URL.createObjectURL(blob);
  triggerDownloadWithAnchorTag(blobUrl, fileName);
};
